import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=71920d59"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71920d59')) {
      api.createRecord('71920d59', component.options)
    } else {
      api.reload('71920d59', component.options)
    }
    module.hot.accept("./Agreements.vue?vue&type=template&id=71920d59", function () {
      api.rerender('71920d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Agreements.vue"
export default component.exports